interface IconProps {
  fill?: string;
}
const AsoEbiIcon = ({ fill }: IconProps) => (
  <svg
    width={24}
    height={19}
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.182 17.403c-.011-5.21-1.541-9.563-2.891-12.197-.435-.849.163-1.966 1.117-1.966h10.685c.242 0 .48.074.67.224 3.881 3.074 4.916 10.018 4.974 14.034.01.626-.506 1.122-1.133 1.122h-12.23c-.664 0-1.19-.554-1.192-1.217"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.413 2.187c1.35 2.634 2.88 6.988 2.89 12.197.002.663.53 1.217 1.192 1.217h2.77c-.136-4.903-1.59-8.99-2.88-11.507-.435-.849.163-1.966 1.116-1.966h8.99A8.8 8.8 0 0 0 12.887.446a1.08 1.08 0 0 0-.671-.225H1.528C.576.221-.022 1.34.413 2.187"
      fill={fill}
    />
  </svg>
);
export { AsoEbiIcon };
